import {
  DESIGNER_SMART_GUILD_ANNUAL_FEE_DEFAULT,
  DESIGNER_SMART_GUILD_FEATURES,
  DESIGNER_SMART_GUILD_MONTHLY_FEE_DEFAULT,
  DESIGNER_SMART_GUILD_TOTAL_ANNUAL_FEE_DEFAULT,
  getDesignerSmartGuildBillingSplit,
  type DesignerSmartGuildBillingSplit,
} from "../../utils/designer-smart-guild-pricing";

type PlanLike = {
  name?: unknown;
  slug?: unknown;
  metadata?: unknown;
};

type DesignerPlanTier = "Home" | "Design" | "Design+";

const DEFAULT_DESIGNER_SMART_GUILD_BILLING_SPLIT: DesignerSmartGuildBillingSplit = {
  annualFeeAmount: DESIGNER_SMART_GUILD_ANNUAL_FEE_DEFAULT,
  monthlyFeeAmount: DESIGNER_SMART_GUILD_MONTHLY_FEE_DEFAULT,
  dueNowAmount: Number(
    (
      DESIGNER_SMART_GUILD_ANNUAL_FEE_DEFAULT +
      DESIGNER_SMART_GUILD_MONTHLY_FEE_DEFAULT
    ).toFixed(2)
  ),
  totalAnnualFeeAmount: DESIGNER_SMART_GUILD_TOTAL_ANNUAL_FEE_DEFAULT,
};

export const resolveDesignerSmartGuildPresentation = (input: {
  isHomeownerAccount: boolean;
  tier: DesignerPlanTier | null | undefined;
  plan: PlanLike | null | undefined;
}) => {
  const shouldUseSmartGuildPresentation =
    !input.isHomeownerAccount && input.tier === "Design";

  if (!shouldUseSmartGuildPresentation) {
    return {
      shouldUseSmartGuildPresentation: false,
      billingSplit: null,
      features: null,
    };
  }

  return {
    shouldUseSmartGuildPresentation: true,
    billingSplit:
      getDesignerSmartGuildBillingSplit(input.plan) ??
      DEFAULT_DESIGNER_SMART_GUILD_BILLING_SPLIT,
    features: [...DESIGNER_SMART_GUILD_FEATURES],
  };
};
